import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { EnvService } from "../../env.service";
import { UserService } from "../services/user.service";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private router: Router,
    private env: EnvService,
  ) {}

  canActivate = (): boolean => {
    var jwt = sessionStorage.getItem(this.env.jwt);
    var loggedIn = jwt;

    if (loggedIn) {
      return true;
    } else {
      this.router.navigate(["/login"]);
    }
  };
}
